export const DOCUMENT_ACTIONS = {
  create: 'create',
  update: 'update',
  delete: 'delete',
  keep: 'keep',
};

export const EDITOR_ACTIONS = {
  selectElement: 'selectElement',
  selectLayout: 'selectLayout',
  selectDocument: 'selectDocument',
};

export const ACTIONS_MENU = [
  {
    name: 'edit',
    label: 'common.edit',
  },
  {
    name: 'delete',
    label: 'common.delete',
  },
];
